import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useClassDetails(data = {}) {
  const { enabled = true, config = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getClassDetails() {
    return privateFetch.get(`/v1/admin/class/meta/details`, config).then((res) => res.data);
  }

  return useQuery(['class-inside-details', { data }], getClassDetails, { enabled });
}

export default useClassDetails;
